import { parseSvgStyle } from '@/icons/utils/svg-styles'
import { ISvgProps } from '@/icons/utils/svg-types'

export const SvgOutlinedCopy = (props: ISvgProps) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            style={parseSvgStyle(props)}
        >
            <g id="copy_24px">
                <path
                    id="icon/content/copy_24px"
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.5 1H4.5C3.39999 1 2.5 1.89999 2.5 3V17H4.5V3H16.5V1ZM19.5 5H8.5C7.39999 5 6.5 5.89999 6.5 7V21C6.5 22.1 7.39999 23 8.5 23H19.5C20.6 23 21.5 22.1 21.5 21V7C21.5 5.89999 20.6 5 19.5 5ZM8.5 21H19.5V7H8.5V21Z"
                    fill={props.color}
                />
            </g>
        </svg>
    )
}
